import { TableRow, TableCell } from '@mui/material';
import { AcademicPeriodData } from '../../../interfaces/TranscriptsInterface';
import { ReactElement } from 'react';
import { ACADEMIC_PERIODS_NAMES } from '../../../constants';
import { TranscriptPrintViewCellFull, TranscriptPrintViewCellPreview } from '../print/TranscriptPrintViewCell';

interface SubjectAreaTablePrintDataProps {
  data: AcademicPeriodData[];
}

function SubjectAreaTablePrintData({ data }: SubjectAreaTablePrintDataProps) {
  const getDataLength = (studentData: AcademicPeriodData) => {
    return (
      studentData.NINTH_GRADE.length +
      studentData.TENTH_GRADE.length +
      studentData.ELEVENTH_GRADE.length +
      studentData.TWELFTH_GRADE.length
    );
  };

  const getRowClass = (rowIndex: number) => {
    return rowIndex % 2 !== 0 ? 'highlighted' : '';
  };

  return (
    <>
      {data.map((studentData, studentIndex) => {
        let dataLength = getDataLength(studentData);
        if (dataLength === 0) {
          return (
            <TableRow key={studentIndex} className={`subject-area-table-row ${getRowClass(studentIndex)}`}>
              <TableCell className="print">Student {studentData.studentNumber}</TableCell>
              <TableCell colSpan={4} className="subject-area-table-cell print empty-row print">
                This student did not take any courses in this subject area
              </TableCell>
            </TableRow>
          );
        }

        let cells: ReactElement[] = [];
        const courseDataKeys = [
          ACADEMIC_PERIODS_NAMES.NINTH_GRADE,
          ACADEMIC_PERIODS_NAMES.TENTH_GRADE,
          ACADEMIC_PERIODS_NAMES.ELEVENTH_GRADE,
          ACADEMIC_PERIODS_NAMES.TWELFTH_GRADE,
        ];
        courseDataKeys.forEach((key, index) => {
          const colData = studentData[key];

          if (!colData.length) {
            cells.push(<TableCell key={`${studentIndex}-${index}`} className="subject-area-table-cell" />);
          } else if (colData.length === 1) {
            cells.push(
              <TableCell key={`${studentIndex}-${index}`} className="subject-area-table-cell print align-top">
                <TranscriptPrintViewCellFull data={colData[0]} />
              </TableCell>
            );
          } else {
            cells.push(
              <TableCell key={`${studentIndex}-${index}`} className="subject-area-table-cell print align-top">
                <TranscriptPrintViewCellPreview data={colData} />
              </TableCell>
            );
          }
        });

        return (
          <TableRow key={studentIndex} className={`subject-area-table-row ${getRowClass(studentIndex)}`}>
            <TableCell className="print">Student {studentData.studentNumber}</TableCell>
            {cells}
          </TableRow>
        );
      })}
    </>
  );
}

export default SubjectAreaTablePrintData;
